var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upsell-summary-items" }, [
    _c(
      "ul",
      { staticClass: "upsell-summary-items-listing" },
      _vm._l(_vm.localData, function(item, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass:
              "upsell-summary-items-listing__item typographies-paragraph-medium-regular"
          },
          [
            _c(
              "div",
              { staticClass: "upsell-summary-items-listing__item-label" },
              [
                _c("span", [
                  _vm.isPlan(item)
                    ? _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Plan ")))])
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.label) +
                      "\n                    "
                  ),
                  _vm.hasQuantity(item)
                    ? _c("span", [_vm._v(" x" + _vm._s(item.quantity))])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.hasTag(item)
                  ? _c("ChargebeeUpsellTag", {
                      attrs: {
                        quantity: item.updatedQuantity,
                        label: _vm.tagLabel(item),
                        "show-quantity": !_vm.isOption(item)
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isPlan(item)
              ? _c(
                  "div",
                  { staticClass: "upsell-summary-items-listing__item-price" },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._f("numberformatCurrency")(
                                _vm.humanizeCentsPrice(item.amount)
                              )
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    item.recurrence
                      ? _c(
                          "span",
                          {
                            staticClass: "typographies-paragraph-small-regular"
                          },
                          [
                            _vm._v(
                              "\n                    /" +
                                _vm._s(_vm.recurrence(item.recurrence)) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }